import * as React from 'react';

import { ClickTracker } from 'bernie-analytics';

import { DestinationPageLink } from 'models';

import { UitkCardTextSegment } from 'uitk-react-cards';
import { UitkLink } from 'uitk-react-link';

const TrackingLink = ClickTracker(UitkLink);

interface LocationEditorialProps {
  body: string;
  neighborhoodTitle: string;
  destinationPageLink?: DestinationPageLink;
}

export const LocationEditorial: React.FunctionComponent<LocationEditorialProps> = ({ body, neighborhoodTitle, destinationPageLink }) => {
  if (!body && !neighborhoodTitle) {
    return null;
  }

  return (
    <React.Fragment>
      <UitkCardTextSegment className="whats-around__location">
        {neighborhoodTitle && (
          <h4 className="location-title uitk-type-heading-500" data-stid="whats-around-neighborhood">
            {neighborhoodTitle}
          </h4>
        )}
        {body && (
          <div className="location-editorial all-y-padding-three" data-stid="whats-around-editorial">
            <p className="uitk-type-paragraph-300">{body}</p>
            {destinationPageLink && <LinkToDX {...destinationPageLink} />}
          </div>
        )}
      </UitkCardTextSegment>
    </React.Fragment>
  );
};

const LinkToDX = ({ url, text }: DestinationPageLink) => (
  <span className="uitk-flex all-y-margin-two">
    <TrackingLink linkName="WhatsAroundLinkDX" rfrr="LINK.DX" inline={true}>
      <a href={url} target="_blank" className="uitk-type-200">
        {text}
      </a>
    </TrackingLink>
  </span>
);
